import React from 'react'
import PropTypes from 'prop-types'

import { NonDismissibleDialog } from '@scoir/modals'

import SendChat from 'components/SendChat'

export default class SendChatModal extends React.Component {
  static propTypes = {
    ...SendChat.propTypes,
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
  }
  render() {
    return (
      <NonDismissibleDialog
        className="send-chat-modal-comp"
        open={this.props.show}
        onClose={this.props.onClose}
        headerText={`${this.props.recipient.school} - ${this.props.recipient.firstName} ${this.props.recipient.lastName}`}
      >
        <NonDismissibleDialog.Body>
          <SendChat {...this.props} />
        </NonDismissibleDialog.Body>
        <NonDismissibleDialog.Footer>
          <NonDismissibleDialog.Footer.CloseButton>Close</NonDismissibleDialog.Footer.CloseButton>
        </NonDismissibleDialog.Footer>
      </NonDismissibleDialog>
    )
  }
}
